import { useUserProfileForm } from "@/hooks/user";
import { CircleNotch, Info, Spinner } from "@phosphor-icons/react";
import toast from "react-hot-toast";
import SelectCountry from "../SelectCountry";
import SelectIndustry from "../SelectIndustry";
import SelectRole from "../SelectRole";
import { useRouter } from "next/router";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import SpinnerComponent from "../Spinner";

function UserProfileForm({ redirect_to }) {
  const {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    companyName,
    jobTitle,
    role,
    industry,
    country,
    setCompanyName,
    setJobTitle,
    setRole,
    setIndustry,
    setCountry,
    isUpdating,
    updateProfile,
    email,
    isLoading,
  } = useUserProfileForm({ onSuccessCallback: onSuccessCallback });

  const router = useRouter();

  function onSuccessCallback(response) {
    toast.success("Profile successfully updated!");
    if (redirect_to) {
      setTimeout(() => {
        router.push(redirect_to);
      }, 300);
    }
  }

  const save = (evt) => {
    evt.preventDefault();
    updateProfile();
  };

  // if (isLoading) {
  //   return (
  //   <div className="h-96 flex justify-center items-center">
  //     <div className="flex gap-x-2">
  //       <SpinnerComponent /><p>Loading Profile...</p>
  //     </div>
  //   </div>
  //   )
  // }

  return (
    <>
      <form onSubmit={save} className='grid grid-cols-12 mt-5 gap-x-4 gap-y-5'>
        <div className='col-span-12 lg:col-span-6 space-y-1.5'>
          <Label className='text-xs'>
            First Name <span className='text-red-500'>*</span>
          </Label>
          <Input
            placeholder='First Name'
            value={firstName}
            onInput={(evt) => setFirstName(evt.target.value)}
            required
          />
        </div>
        <div className='col-span-12 lg:col-span-6 space-y-1.5'>
          <Label className='text-xs'>
            Last Name <span className='text-red-500'>*</span>
          </Label>
          <Input
            placeholder='Last Name'
            value={lastName}
            onInput={(evt) => setLastName(evt.target.value)}
            required
          />
        </div>
        <div className='col-span-12 lg:col-span-6 space-y-1.5'>
          <Label className='text-xs'>
            Company <span className='text-red-500'>*</span>
          </Label>
          <Input
            placeholder='Company'
            value={companyName}
            onInput={(evt) => setCompanyName(evt.target.value)}
            required
          />
        </div>
        <div className='col-span-12 lg:col-span-6 space-y-1.5'>
          <Label className='text-xs'>
            Job Title <span className='text-red-500'>*</span>
          </Label>
          <Input
            placeholder='Job Title'
            value={jobTitle}
            onInput={(evt) => setJobTitle(evt.target.value)}
            required
          />
        </div>
        <div className='col-span-12 lg:col-span-6 space-y-1.5'>
          <Label className='text-xs'>
            Role <span className='text-red-500'>*</span>
          </Label>
          <SelectRole
            isModal={false}
            value={role}
            onChange={(value) => setRole(value)}
          />
        </div>
        <div className='col-span-12 lg:col-span-6 space-y-1.5'>
          <Label className='text-xs'>
            Industry <span className='text-red-500'>*</span>
          </Label>
          <SelectIndustry
            isModal={false}
            value={industry}
            onChange={(value) => setIndustry(value)}
          />
        </div>
        <div className='col-span-12 lg:col-span-6 space-y-1.5'>
          <Label className='text-xs'>
            Country <span className='text-red-500'>*</span>
          </Label>
          <SelectCountry
            isModal={false}
            value={country}
            onChange={(value) => setCountry(value)}
          />
        </div>
        <div className='col-span-12 lg:col-span-6 space-y-1.5'>
          <Label className='text-xs'>Email</Label>
          <Input value={email} disabled />
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <p className='inline-flex items-center text-xs border-b border-dashed text-white/30 border-white/10'>
                  <Info className='mr-1' />
                  Why i cannot change my email?
                </p>
              </TooltipTrigger>
              <TooltipContent>
                <p className='text-xs'>
                  You cannot change your email because it will be used for
                  startup validation
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <div className='flex col-span-12'>
          <Button disabled={isUpdating} className='w-full lg:w-auto'>
            {isUpdating && (
              <CircleNotch
                weight='bold'
                className='mr-2 text-lg animate-spin'
              />
            )}
            {isUpdating ? "Updating..." : "Save Changes"}
          </Button>
        </div>
        {/*
        <div className='flex flex-col gap-2'>
          <p className='input-label'>Upload Profile Picture</p>

          <label
            htmlFor='profile-picture'
            className='inline-block px-4 py-2 text-white duration-300 ease-out border border-white rounded opacity-50 cursor-pointer w-max hover:bg-white hover:text-dark-2 hover:opacity-100'
          >
            Upload Profile Picture
          </label>
          <input id='profile-picture' type='file' className='hidden' />
        </div>
        <button type='submit' className='btn-gradation' disabled={isUpdating}>
          {isUpdating && <Spinner />}
          {isUpdating ? "Sending Data ..." : "Save Changes"}
        </button> */}
      </form>
    </>
  );
}

export default UserProfileForm;
